import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useState } from 'react'

import { ActionFab } from '../../../components/ActionButton'
import { Icon } from '../../../components/Icon'
import { PageTitle } from '../../../components/PageTitle'
import { useHasRole } from '../../../helpers'
import ContestManualApplicationModal from './ContestManualApplicationModal'
import ContestsLabelsModal from './ContestsLabelsModal'
import ContestsSendEmailsModal from './ContestsSendEmailsModal'
import ApplicationsTab from './tabs/ApplicationsTab'
import ArtworksTab from './tabs/ArtworksTab'

export default function ContestsApplicationsPage() {
  const hasRole = useHasRole()
  const permissions = {
    sendEmails: hasRole('send_email_notifications'),
    createManualApplication: hasRole('create_manual_contest_application')
  }
  const [isSendEmailsModalOpen, setIsSendEmailsModalOpen] = useState(false)
  const [isLabelsModalOpen, setIsLabelsModalOpen] = useState(false)
  const [isManualApplicationModalOpen, setIsManualApplicationModalOpen] = useState(false)
  // Sobe a cada inscrição manual registrada, e a aba de inscrições recarrega a lista
  const [applicationsReloadKey, setApplicationsReloadKey] = useState(0)
  // O concurso escolhido é da página, não de cada aba: com `isLazy` a aba é desmontada ao
  // trocar, e o filtro que morava dentro dela voltava vazio toda vez.
  const [selectedContest, setSelectedContest] = useState('')

  // A pilha de FABs vai de baixo para cima — inscrição manual, e-mails, etiquetas — e cada um sobe
  // uma posição por FAB visível abaixo dele.
  const showSendEmailsFab = permissions.sendEmails && !!selectedContest
  const sendEmailsStackIndex = permissions.createManualApplication ? 1 : 0
  const labelsStackIndex = sendEmailsStackIndex + (showSendEmailsFab ? 1 : 0)

  return (
    <>
      <PageTitle title="Inscrições de Concursos" description="Inscrições e obras enviadas pelos participantes" mb={6} />

      <Tabs isLazy>
        <TabList>
          <Tab>Inscrições</Tab>
          <Tab>Obras</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <ApplicationsTab
              contestName={selectedContest}
              onContestFilterChange={setSelectedContest}
              reloadKey={applicationsReloadKey}
            />
          </TabPanel>
          <TabPanel>
            <ArtworksTab contestName={selectedContest} onContestFilterChange={setSelectedContest} />
          </TabPanel>
        </TabPanels>
      </Tabs>

      {selectedContest && (
        <ActionFab
          icon={<Icon name="lni lni-tag" />}
          label="Emitir etiquetas de obras"
          stackIndex={labelsStackIndex}
          onClick={() => setIsLabelsModalOpen(true)}
        />
      )}

      {showSendEmailsFab && (
        <ActionFab
          icon={<Icon name="lni lni-envelope" />}
          label="Enviar e-mails para inscritos"
          stackIndex={sendEmailsStackIndex}
          onClick={() => setIsSendEmailsModalOpen(true)}
        />
      )}

      {permissions.createManualApplication && (
        <ActionFab label="Inscrição manual" onClick={() => setIsManualApplicationModalOpen(true)} />
      )}

      {/* Labels Modal */}
      <ContestsLabelsModal
        isOpen={isLabelsModalOpen}
        onClose={() => setIsLabelsModalOpen(false)}
        preSelectedContestName={selectedContest}
      />

      {/* Send Email's Modal */}
      <ContestsSendEmailsModal
        isOpen={isSendEmailsModalOpen}
        onClose={() => setIsSendEmailsModalOpen(false)}
        preSelectedContestName={selectedContest}
      />

      <ContestManualApplicationModal
        isOpen={isManualApplicationModalOpen}
        onClose={() => setIsManualApplicationModalOpen(false)}
        onCreated={() => setApplicationsReloadKey((key) => key + 1)}
        initialContestName={selectedContest}
      />
    </>
  )
}
